import { Grid, Typography } from '@material-ui/core';
import moment from 'moment';
import { AppStorage } from '../../../../../Core/Service/storage-service';
import { useState } from 'react';
import './tcardTemplate.scss';
import DriveEtaIcon from '@material-ui/icons/DriveEta';
import BuildIcon from '@material-ui/icons/Build';
import MonetizationOnIcon from '@material-ui/icons/MonetizationOn';
import WorkIcon from '@material-ui/icons/Work';
import AccountCircleIcon from '@material-ui/icons/AccountCircle';
import HourglassFullIcon from '@material-ui/icons/HourglassFull';
import TodayIcon from '@material-ui/icons/Today';
import EventNoteIcon from '@material-ui/icons/EventNote';
import LocationOnIcon from '@material-ui/icons/LocationOn';
import GroupIcon from '@material-ui/icons/Group';
// import WorkIcon from '@material-ui/icons/Work';

export const Tcard = ({
    customer,
    registration,
    color,
    isLoanVehicle,
    status,
    date,
    tCardsID,
    handleTcardOpen,
    textColor,
    legendItems,
    hideBookingDate,
    wn,
    vsc,
    days,
    breakdown,
    breakdownStatus,
    breakdownTime,
    pt,
    workDetails,
    list,
    technicians,
    isTCard
}) => {
    // const {} = list;
    const portalSetting = AppStorage.getPortalSetting();
    // const classes = useStyles();
    const [hovered, setHovered] = useState(false);
    return (
        <div
            style={{ background: color || '#FFFFFF', height: hideBookingDate ? 45 : '' }}
            className={'Tcard'}
            onClick={(e) => {
                e.stopPropagation();
                handleTcardOpen && handleTcardOpen(true, tCardsID, false, color);
            }}
        >
            <Grid container justifyContent="space-between" spacing={0}>
                <Grid
                    item
                    xs={12}
                    style={{
                        display: 'flex',
                        alignItems: 'center', // 👈 keeps everything vertically aligned
                        gap: 3, // small horizontal gap
                        lineHeight: 1, // reduces extra height from inline elements
                        justifyContent: 'space-between'
                        // borderBottom: '1px dotted lightgrey',
                        // padding: 3
                    }}
                >
                    <div
                        style={{
                            fontSize: 12,
                            fontWeight: 600,
                            textAlign: 'left',
                            color: textColor || '#000000',
                            whiteSpace: 'nowrap'
                        }}
                    >
                        {registration}
                    </div>
                    <div
                        style={{
                            display: 'flex',
                            alignItems: 'center',
                            gap: 5
                        }}
                    >
                        <div
                            style={{
                                width: 15,
                                height: 15,
                                borderRadius: '50%',
                                background: '#EEF2FF',
                                display: 'flex',
                                alignItems: 'center',
                                justifyContent: 'center'
                            }}
                        >
                            <DriveEtaIcon
                                style={{
                                    fontSize: 11,
                                    color: vsc || '#5C6BC0'
                                }}
                            />
                        </div>

                        <div
                            style={{
                                width: 15,
                                height: 15,
                                borderRadius: '50%',
                                background: '#FDECEC',
                                display: 'flex',
                                alignItems: 'center',
                                justifyContent: 'center'
                            }}
                        >
                            <BuildIcon
                                style={{
                                    fontSize: 11,
                                    color: breakdown ? '#E53935' : '#9E9E9E'
                                }}
                            />
                        </div>

                        {pt === 'Cash' && (
                            <div
                                style={{
                                    width: 15,
                                    height: 15,
                                    borderRadius: '50%',
                                    background: '#FFF8E1',
                                    display: 'flex',
                                    alignItems: 'center',
                                    justifyContent: 'center'
                                }}
                            >
                                <span
                                    style={{
                                        color: '#D4A017',
                                        fontSize: 11,
                                        fontWeight: 700
                                    }}
                                >
                                    £
                                </span>
                            </div>
                        )}

                        {isLoanVehicle && (
                            <div
                                style={{
                                    width: 15,
                                    height: 15,
                                    borderRadius: '50%',
                                    background: portalSetting.portalSettingsLoanVehicleBgColor,
                                    display: 'flex',
                                    alignItems: 'center',
                                    justifyContent: 'center',
                                    color: portalSetting.portalSettingsLoanVehicleTextColor,
                                    fontSize: 10,
                                    fontWeight: 700
                                }}
                            >
                                {portalSetting.portalSettingsLoanVehicleText}
                            </div>
                        )}

                        {(isTCard || Boolean(tCardsID)) && (
                            <div
                                style={{
                                    width: 15,
                                    height: 15,
                                    borderRadius: '50%',
                                    background: '#183B68',
                                    display: 'flex',
                                    alignItems: 'center',
                                    justifyContent: 'center',
                                    color: '#FFFFFF',
                                    fontSize: 10,
                                    fontWeight: 700,
                                    lineHeight: 1
                                }}
                                title="T-Card Job"
                            >
                                T
                            </div>
                        )}
                    </div>
                </Grid>
                <Grid item xs={12} container spacing={1} style={{ marginTop: 1 }}>
                    <Grid item xs={6}>
                        <div
                            style={{
                                fontSize: 11,
                                fontWeight: 600,
                                textAlign: 'right',
                                color: textColor || '#000000',
                                gap: 3,
                                alignItems: 'center',
                                // justifyContent: 'flex-end',
                                alignContent: 'center',
                                display: 'flex'
                            }}
                        >
                            {' '}
                            {/* <span>
                                <TodayIcon style={{ fontSize: 12 }} />
                            </span>{' '} */}
                            <span>{days}</span>
                        </div>
                        {/* <Typography style={{ fontSize: 10, fontWeight: 900, textAlign: 'left', color: textColor }}>{days}</Typography> */}
                    </Grid>
                    {wn && (
                        <Grid item xs={6}>
                            {/* <div style={{ display: 'flex', gap: 3, alignItems: 'center', justifyContent: 'flex-end' }}> */}
                            <div
                                style={{
                                    fontSize: 11,
                                    fontWeight: 600,
                                    textAlign: 'right',
                                    color: textColor || '#000000',
                                    gap: 3,
                                    alignItems: 'center',
                                    justifyContent: 'flex-end',
                                    alignContent: 'center',
                                    display: 'flex'
                                }}
                            >
                                {' '}
                                {/* <span>
                                    <WorkIcon style={{ fontSize: 12 }} />
                                </span>{' '} */}
                                <span>{wn}</span>
                            </div>
                        </Grid>
                    )}
                </Grid>

                <Grid item xs={12}>
                    {breakdownTime && breakdownStatus && (
                        <Typography
                            style={{ fontSize: 9, fontWeight: 600, textAlign: 'left', color: textColor || '#000000' }}
                        >{`Breakdown : (${breakdownTime} Hrs)    ${breakdownStatus}`}</Typography>
                    )}
                    <div
                        style={{
                            fontSize: 10,
                            fontWeight: 600,
                            textAlign: 'left',
                            color: textColor || '#333333',
                            gap: 3,
                            alignItems: 'center',
                            // justifyContent: 'flex-end',
                            display: 'flex'
                        }}
                    >
                        {' '}
                        {/* <AccountCircleIcon style={{ fontSize: 11 }} />  */}
                        <span>{customer}</span>
                    </div>
                </Grid>

                {/* <Grid item xs={12}></Grid> */}
            </Grid>
            <Grid container justifyContent="space-between" alignItems="center">
                {!hideBookingDate && (
                    <Grid item xs={12}>
                        <div
                            style={{
                                fontSize: 11,
                                fontWeight: 600,
                                textAlign: 'right',
                                color: textColor,
                                gap: 3,
                                alignItems: 'center',
                                // justifyContent: 'flex-end',
                                alignContent: 'center',
                                display: 'flex'
                            }}
                        >
                            {' '}
                            {/* <span>
                                <EventNoteIcon style={{ fontSize: 12 }} />
                            </span>{' '} */}
                            <span>{moment(date).format('DD/MM/YYYY HH:mm')}</span>
                        </div>

                        {/* <Typography
                            style={{
                                fontSize: 10,
                                fontWeight: 600,
                                textAlign: 'left',
                                color: textColor
                            }}
                        >
                            {/* {date
                                ? moment(date).hour() === 0 && moment(date).minute() === 0
                                    ? moment(date).format('DD/MM') // if time is 00:00
                                    : moment(date).format('DD/MM HH:mm') // otherwise include time
                                : 'N/A'} */}
                        {/* {moment(date).format('DD/MM/YYYY HH:mm')}
                        </Typography> */}
                    </Grid>
                )}
                {technicians && (
                    <Grid item xs={12}>
                        <div
                            style={{
                                fontSize: 9,
                                fontWeight: 600,
                                textAlign: 'right',
                                color: textColor,
                                gap: 3,
                                alignItems: 'center',
                                // justifyContent: 'flex-end',
                                alignContent: 'center',
                                display: 'flex'
                            }}
                        >
                            {' '}
                            {/* <span>
                                <GroupIcon style={{ fontSize: 12 }} />
                            </span>{' '} */}
                            <span> {technicians}</span>
                        </div>
                        {/* <Typography style={{ fontSize: 9, fontWeight: 600, textAlign: 'left', color: textColor }}>
                            {status.motloc} ({moment(status.motdate).format('DD-MM-YYYY HH:mm')})
                        </Typography> */}
                    </Grid>
                )}
                {workDetails && (
                    <Grid item xs={12}>
                        <div
                            style={{
                                fontSize: 11,
                                fontWeight: 600,
                                textAlign: 'left',
                                color: textColor,
                                gap: 3,
                                alignItems: 'center',
                                // justifyContent: 'flex-end',
                                alignContent: 'center',
                                display: 'flex'
                            }}
                        >
                            {' '}
                            {/* <span>
                                <WorkIcon style={{ fontSize: 12 }} />
                            </span>{' '} */}
                            <span>{workDetails}</span>
                        </div>
                        {/* <Typography
                        style={{
                            fontSize: 10,
                            fontWeight: 600,
                            textAlign: 'left',
                            color: textColor
                        }}
                    >
                        {workDetails}ss
                    </Typography> */}
                    </Grid>
                )}

                <Grid item xs={12}>
                    {/* {status && ( */}
                    <div style={{ display: 'grid', rowGap: 1, gridTemplateColumns: 'repeat(9, 1fr)', justifyContent: 'start' }}>
                        {legendItems?.map((k) => {
                            if (status[k.st]) {
                                return (
                                    <div key={k.st} style={{ margin: '0px 2px' }}>
                                        <Typography
                                            style={{
                                                fontSize: 8,
                                                fontWeight: 600,
                                                background: k.background,
                                                color: k.color ? k.color : 'white',
                                                padding: 2
                                            }}
                                        >
                                            {k.label}
                                        </Typography>
                                    </div>
                                );
                            } else {
                                return (
                                    <div key={k.st} style={{ margin: '0px 2px' }}>
                                        <Typography
                                            style={{
                                                fontSize: 6,
                                                fontWeight: 600,
                                                // background: k.background,
                                                color: 'white',
                                                padding: 2
                                            }}
                                        ></Typography>
                                    </div>
                                );
                            }
                        })}
                    </div>
                    {/* )} */}
                </Grid>
                {status.motloc && (
                    <Grid item xs={12}>
                        <div
                            style={{
                                fontSize: 11,
                                fontWeight: 600,
                                textAlign: 'right',
                                color: textColor,
                                gap: 3,
                                alignItems: 'center',
                                // justifyContent: 'flex-end',
                                alignContent: 'center',
                                display: 'flex'
                            }}
                        >
                            {' '}
                            {/* <span>
                                <LocationOnIcon style={{ fontSize: 12 }} />
                            </span>{' '} */}
                            <span>
                                {' '}
                                {status.motloc} ({moment(status.motdate).format('DD-MM-YYYY HH:mm')})
                            </span>
                        </div>
                        {/* <Typography style={{ fontSize: 9, fontWeight: 600, textAlign: 'left', color: textColor }}>
                            {status.motloc} ({moment(status.motdate).format('DD-MM-YYYY HH:mm')})
                        </Typography> */}
                    </Grid>
                )}
            </Grid>
        </div>
    );
};
